import React from "react";
import { Shield, Crown } from "lucide-react";
import PhoneOtpLogin from "./PhoneOtpLogin";
import { useAuth } from "../lib/auth";
import { getTenantSlug } from "../lib/tenant";

export default function AdminLogin({ superAdmin = false }) {
  const { tenant } = useAuth();
  if (superAdmin) {
    return (
      <PhoneOtpLogin
        role="super_admin"
        title="Super Admin"
        subtitle="Platform Console"
        icon={Crown}
        accentClass="bg-brand-clay"
        buttonClass="bg-brand-clay hover:bg-orange-700"
        channelActiveClass="border-brand-clay bg-brand-clay/10 text-brand-clay"
        defaultPhone="9858558555"
        redirectTo="/super/dashboard"
        dark
        testIdPrefix="super-admin-login"
      />
    );
  }
  const brand = tenant?.name?.trim();
  const subtitle = brand ? `${brand} Console` : "Operator Console";
  // Only show the seeded tenant admin demo phone on the default dairyfresh
  // tenant. Real tenants get an empty input so their owners can't be misled
  // into typing the demo number.
  const isDemoTenant = getTenantSlug() === "dairyfresh";
  return (
    <PhoneOtpLogin
      role="tenant_admin"
      altRole="supervisor"
      title="Dairy Admin"
      subtitle={subtitle}
      icon={Shield}
      accentClass="bg-brand-sky"
      buttonClass="bg-brand-sky hover:bg-blue-700"
      channelActiveClass="border-brand-sky bg-brand-sky/10 text-brand-sky"
      defaultPhone={isDemoTenant ? "+919999900001" : ""}
      tenantSlug={getTenantSlug()}
      redirectTo="/admin/dashboard"
      testIdPrefix="tenant-admin-login"
    />
  );
}
